import { isEmpty } from "lodash";
import React, { useState, useEffect } from "react";

import { Trans, useTranslation } from "react-i18next";
import ValidationError from "../Shared/ValidationError";

import BaseModal from "./BaseModal";

const DevicesModal = ({
    showDevicesModal,
    setShowDevicesModal,
    isModalSubmitting,
    data,
    setData,
    isSupport,
    createDeviceAction,
    updateDeviceAction,
    error,
    isFromSubmitted,
}) => {
    const [editMode, setEditMode] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        showDevicesModal ? setEditMode(!isEmpty(data)) : setData({});
    }, [showDevicesModal]);

    const getTitle = () => {
        return editMode ? t("updateDevice") : t("addNewDevice");
    };

    const handleInputChange = (e) => {
        setData((prevParams) => {
            return {
                ...prevParams,
                [e.target.name]: e.target.value?.trim(),
            };
        });
    };

    const returnErrorMessages = (propName) => {
        return isFromSubmitted && error[propName];
    };

    const renderChildren = () => (
        <>
            <div
                className={`input-group ${
                    returnErrorMessages("name") ? "invalid-warning-input" : ""
                }`}
            >
                <label className="uppercase required">
                    <Trans i18nKey="deviceName">Device Name</Trans>
                </label>
                <input
                    className="input-element"
                    name="name"
                    type="text"
                    onChange={handleInputChange}
                    value={data?.name || ""}
                    placeholder={t("inputPlaceholder", {
                        entity: t("deviceName"),
                    })}
                />
                <ValidationError errorMessage={returnErrorMessages("name")} />
            </div>
            {isSupport() && (
                <div
                    className={`input-group ${
                        returnErrorMessages("firmwareVersion")
                            ? "invalid-warning-input"
                            : ""
                    }`}
                >
                    <label className="uppercase">
                        <Trans i18nKey="firmwareVersion">
                            Firmware Version
                        </Trans>
                    </label>
                    <input
                        className="input-element"
                        type="text"
                        name="firmwareVersion"
                        onChange={handleInputChange}
                        value={data?.firmwareVersion || ""}
                        placeholder={t("versionPlaceholder")}
                    />
                    <ValidationError
                        errorMessage={returnErrorMessages("firmwareVersion")}
                    />
                </div>
            )}
        </>
    );

    return (
        <BaseModal
            isVisible={showDevicesModal}
            setIsVisible={setShowDevicesModal}
            isSubmitting={isModalSubmitting}
            title={getTitle()}
            action={{
                submitAction: editMode
                    ? updateDeviceAction
                    : createDeviceAction,
                disabled: isModalSubmitting,
            }}
            isSmall={true}
        >
            {renderChildren()}
        </BaseModal>
    );
};

export default DevicesModal;
